
    import Chart from "chart.js/auto"

    export default {
      mounted() { this.render() },
      updated() { this.chart?.destroy(); this.render() },
      destroyed() { this.chart?.destroy() },
      render() {
        const points = JSON.parse(this.el.dataset.points)
        const canvas = this.el.querySelector("canvas")
        const percent = this.el.dataset.kind === "percent"
        const max = this.el.dataset.max ? parseInt(this.el.dataset.max) : undefined

        this.chart = new Chart(canvas, {
          type: "bar",
          data: {
            labels: points.map((point) => point.date),
            datasets: [
              {
                label: percent ? "% auto-matched" : "Incorrectly matched",
                data: points.map((point) => (percent ? point.percentage : point.incorrect)),
                backgroundColor: percent ? "#2563eb" : "#dc2626",
              },
            ],
          },
          options: {
            onClick: (event, elements) => {
              if (!elements.length) return
              const point = points[elements[0].index]
              if (point.url) window.open(point.url, "_blank")
            },
            onHover: (event, elements) => {
              event.native.target.style.cursor = elements.length ? "pointer" : "default"
            },
            scales: {
              y: percent
                ? { beginAtZero: true, max: 100, ticks: { callback: (value) => `${value}%` } }
                : { beginAtZero: true, max: max, ticks: { precision: 0 } },
            },
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: {
                  afterLabel: (ctx) => {
                    if (!percent) return
                    const point = points[ctx.dataIndex]
                    return `${point.matched}/${point.reached} letters`
                  },
                },
              },
            },
          },
        })
      },
    }
  